import { selectors } from 'modules/common';
import { domain, State } from 'modules/data';
import { useSelector } from 'react-redux';

import { getActiveTemplate } from '../../../../selectors/pageSelectors';

export const useShowBadges = () => {
    const activeTemplate = useSelector(getActiveTemplate);
    const company = useSelector((state: State) =>
        activeTemplate ? selectors.company.findCompanyById(state, activeTemplate.companyId) : undefined
    );
    const template = useSelector(getActiveTemplate)!;

    const expandedTemplate = selectors.template.expandTemplate(template);
    const isAirwallexBatchPayment =
        expandedTemplate.integrationCode === domain.IntegrationCode.XeroAirwallexBatchPayment;
    const isBatchPayment = expandedTemplate.integrationCode === domain.IntegrationCode.XeroBillBatchPayment;
    const integrationType = selectors.integration.getIntegrationType(template.integrationCode);
    const isStandalone = integrationType === domain.IntegrationType.None;
    const showPremiumBadge =
        (isBatchPayment || isStandalone || isAirwallexBatchPayment) &&
        company &&
        (company.flags.isAllFeaturesTrialActive || company.flags.isTrialLicense);

    // No features are under "BETA" flag ATM. Leaving this for the future purposes
    // eslint-disable-next-line no-constant-binary-expression
    const showBetaBadge = false && !showPremiumBadge;

    return { showPremiumBadge, showBetaBadge };
};
